var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MobAdSearcher',{staticClass:"hide-on-print"}),_c('MobAdForm'),_c('ViewInfo'),_c('ReportMobAdsPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }